import { App } from '@ps20-frontend/frontend-models';
import { ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';

export function getSuccessEventForShop(appId: App): string {
  const eventMappings = {
    [App.VWG]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG,
    [App.VWG_V2]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_VWG_V2,
    [App.VHV]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV,
    [App.VHV_V2]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV_V2,
    [App.PH]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_PH,
    [App.RS]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_RS,
    [App.RS_VERMIETUNG]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_RS_VM,
    [App.THH_HUND]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_HUND,
    [App.THH_PFERD]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_PFERD,
    [App.TKV]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV,
    [App.TKV_V2]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_TKV_V2,
    [App.UNF]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_UNF,
    [App.JHP]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_JHP,
    [App.GEGE]: ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_GEGE,
  };
  const eventMapping = (eventMappings as Record<string, string>)[appId];
  if (eventMapping == null) {
    console.error(`Kein SuccessEventForShop für appID: ${appId} vorhanden!`);
  }
  return eventMapping;
}
